export const CALENDAR_GRID_MODE_PARAM = 'calendar_mode'

export const CALENDAR_GRID_TODAY_ANCHOR_OFFSET = 0

export const CALENDAR_GRID_AGENDA_DAY_COUNT = 14

export const CALENDAR_GRID_DAY_MODE_DAY_COUNT = 1
